import React from "react";
import { Col } from "react-bootstrap";
import { Money, RoundedNumber } from "shared/components";
import StartupDashboardWidget from "./StartupDashboardWidget";

export default function GeneralMetricsWidget(props) {
  if (!props.productLineAnalytics) {
    return <GeneralMetricsWidgetForFetchingData />;
  }

  const {
    absolute_sales_revenue: absoluteSalesRevenue,
    absolute_sample_order_count: absoluteSampleOrderCount,
    absolute_selling_merchant_store_count: absoluteSellingMerchantStoreCount,
  } = props.productLineAnalytics;

  return (
    <>
      <GeneralMetricsWidgetContainer>
        <Col xs={4}>
          <GeneralMetricsWidgetEntry entryTitle="Umsatz bei EDEKA">
            {absoluteSalesRevenue && (
              <Money absolute value={absoluteSalesRevenue} />
            )}
          </GeneralMetricsWidgetEntry>
        </Col>

        <Col xs={4}>
          <GeneralMetricsWidgetEntry entryTitle="Probebestellungen">
            {absoluteSampleOrderCount && (
              <RoundedNumber value={absoluteSampleOrderCount} />
            )}
          </GeneralMetricsWidgetEntry>
        </Col>

        <Col xs={4}>
          <GeneralMetricsWidgetEntry entryTitle="Anzahl verkaufender Märkte">
            {absoluteSellingMerchantStoreCount && (
              <RoundedNumber value={absoluteSellingMerchantStoreCount} />
            )}
          </GeneralMetricsWidgetEntry>
        </Col>
      </GeneralMetricsWidgetContainer>
      <small style={{ textTransform: "none", fontSize: "9px" }}>(*) nur Produkte mit Status &quot;live&quot; enthalten</small >
    </>
  );
}

const GeneralMetricsWidgetContainer = props => {
  return (
    <StartupDashboardWidget
      id="general-metrics-widget"
      header={<GeneralMetricsWidgetHeader />}
      subHeader={<GeneralMetricsWidgetSubHeader />}
      {...props}
    >
      {props.children}
    </StartupDashboardWidget>
  );
};

const GeneralMetricsWidgetHeader = () => {
  return <span className="dashboard-box-header-title">Kennzahlen</span>;
};

const GeneralMetricsWidgetSubHeader = () => {
  return <span className="text-right pull-right">Seit Veröffentlichung (*)</span>;
};

const GeneralMetricsWidgetForFetchingData = () => {
  return (
    <GeneralMetricsWidgetContainer>
      <Col md={12}>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          Loading ...
        </div>
      </Col>
    </GeneralMetricsWidgetContainer>
  );
};

const GeneralMetricsWidgetEntry = props => {
  return (
    <div id={props.id} className="metric-entry">
      <div className="metric-entry-value">
        {props.children || <span>–</span>}
      </div>
      <div className="metric-entry-title">{props.entryTitle}</div>
    </div>
  );
};
